import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { ApolloProvider } from '@apollo/client';

import { useApollo } from './useApolloClient';

type Props = { children: React.ReactNode };

const GraphqlProvider = ({ children, ...pageProps }: Props) => {
  const router = useRouter();
  const isAdminRoute = router.pathname.startsWith('/admin');

  const apolloClient = useApollo({
    ...pageProps,
    isAdminRoute,
  });

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};

export default GraphqlProvider;
